import { render, staticRenderFns } from "./Postgrados.vue?vue&type=template&id=79acfdbc"
import script from "./Postgrados.vue?vue&type=script&lang=js"
export * from "./Postgrados.vue?vue&type=script&lang=js"
import style0 from "./Postgrados.vue?vue&type=style&index=0&id=79acfdbc&prod&lang=css&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports